import React from 'react';
import { Button } from 'react-bootstrap';
/**
 * An expanded red error button that takes a props object with String message and a function onClick.
 * @param {*} props
 * @returns JSX Element
 */
export function HHIEError(props) {
    return (
        <div className="d-grid gap-2">
            <Button 
                style={{
                    color: '#721c24', 
                    backgroundColor: '#f8d7da', 
                    borderColor: '#f5c6cb'
                }}
                onClick={(props.onClick) ? props.onClick : () => alert("Onclick function is not implemented.")}
                onMouseEnter={(e) => {e.target.style.backgroundColor = '#F8C1C8'}}
                onMouseLeave={(e) => {e.target.style.backgroundColor = '#f8d7da'}}
            >
                {props.message}
            </Button>
        </div>
    )
}
